import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const UserActions = ({ onDownload, onFileUpload, isDownloading }) => {
  return (
    <div className="flex space-x-4">
      <button
        className="px-4 py-2.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors duration-200 flex items-center space-x-2 dark:bg-green-600 dark:hover:bg-green-700"
        onClick={onDownload}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <div className="flex items-center space-x-2">
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span>Đang tải...</span>
          </div>
        ) : (
          <>
            <i className="fas fa-download"></i>
            <span>Tải xuống</span>
          </>
        )}
      </button>

      <div className="flex flex-row items-center justify-end space-x-8">
        <button
          className="px-4 py-2.5 bg-yellow-500 hover:text-white text-white rounded-lg hover:bg-yellow-600 transition-colors duration-200 flex items-center space-x-2 dark:bg-yellow-600 dark:hover:bg-yellow-700"
          onClick={() => document.getElementById("fileInput").click()}
        >
          Cập nhật doanh thu
        </button>
        <input
          id="fileInput"
          type="file"
          accept=".xlsx, .xls"
          onChange={onFileUpload}
          className="hidden"
        />
      </div>

      <Link
        to="/create-user"
        className="px-4 py-2.5 bg-blue-500 hover:text-white text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 flex items-center space-x-2 dark:bg-blue-600 dark:hover:bg-blue-700"
      >
        <FontAwesomeIcon icon={faPlus} />
        Thêm mới
      </Link>
    </div>
  );
};

export default UserActions;
